import { Dialog } from "@headlessui/react";
import { ModalFoterBox } from "../../components/box/Box";
import Button from "../../components/button/Button";
import { Modal, ModalProp } from "../../components/modal/Modal";

export type ConfirmAnswerModalProps = {
  handleConfirm: () => void;
  isLoad: boolean;
  isStaffConfirmed : boolean;
  isMunicipalityConfirmed : boolean;
  staffConfirmed : boolean;
}

export const ConfirmAnswerModal = ({
  open,
  toggle,
  closeOnClickOutside,
  handleConfirm,
  isLoad,
  isStaffConfirmed,
  isMunicipalityConfirmed,
  staffConfirmed,
}: ModalProp & ConfirmAnswerModalProps) => {
  return (
    <Modal
      open={open}
      toggle={toggle}
      closeOnClickOutside={closeOnClickOutside}
    >
      {isMunicipalityConfirmed ? (
        <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all">
          <div className="px-2 pb-4 sm:p-4">
            <div className="text-center sm:mt-3">
              <Dialog.Title
                as="h3"
                className="text-left leading-6 text-gray-900"
              >
                返信情報の確定を解除しますか？
              </Dialog.Title>
            </div>
          </div>
          <ModalFoterBox>
            <Button
              className="mx-2 mt-1 w-[132px]"
              outline
              onClick={toggle}
              children={"キャンセル"}
            />
            <Button
              className="mt-1 mr-2 w-[132px]"
              onClick={handleConfirm}
              children={"解除"}
              disabled={isLoad}
            />
          </ModalFoterBox>
        </Dialog.Panel>
      ) : (
        <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all">
          <div className="px-2 pb-4 sm:p-4">
            <div className="text-center sm:mt-3">
              <Dialog.Title
                as="h3"
                className="text-left leading-6 text-gray-900"
              >
                返信情報を確定すると変更できなくなります。確定してよろしいですか？
              </Dialog.Title>
            </div>
            <div className="mt-5 text-red-600">
              {!isStaffConfirmed && staffConfirmed ? "※イベントサポート側では返信情報未確定です" : ""}
            </div>
          </div>
          <ModalFoterBox>
            <Button
              className="mx-2 mt-1 w-[132px]"
              outline
              onClick={toggle}
              children={"キャンセル"}
            />
            <Button
              className="mt-1 mr-2 w-[132px]"
              onClick={handleConfirm}
              children={"確定"}
              disabled={isLoad}
            />
          </ModalFoterBox>
        </Dialog.Panel>
      )}
    </Modal>
  );
};